import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import DealDto from "../../dto/Deal/DealDto";
import {
  CreateSpecialDealRequestDto,
  ListSpecialDealsRequestDto,
} from "../../api/apiServices/backOffice/controllers/specialDeals/specialDeals.requestsDto";

const initialState: {
  loading: boolean;
  saving: boolean;
  error: boolean;
  deals: Pick<DealDto, "id" | "number" | "name">[];
  total: number;
  page: number;
  createdId?: number;
} = {
  loading: false,
  saving: false,
  error: false,
  deals: [],
  total: 0,
  page: 0,
};
const slice = createSlice({
  name: "specialDeals",
  initialState,
  reducers: {
    load(state, action: PayloadAction<ListSpecialDealsRequestDto>) {
      state.loading = true;
      state.error = false;
      state.page = action.payload.page;
    },
    loadSuccess(state, action: PayloadAction<{ deals: Pick<DealDto, "id" | "number" | "name">[]; total: number }>) {
      state.loading = false;
      state.deals = action.payload.deals;
      state.total = action.payload.total;
    },
    loadReject(state) {
      state.loading = false;
      state.error = true;
    },
    create(state, _action: PayloadAction<CreateSpecialDealRequestDto>) {
      state.saving = true;
      state.error = false;
      state.createdId = undefined;
    },
    createSuccess(state, action: PayloadAction<number>) {
      state.saving = false;
      state.createdId = action.payload;
    },
    createReject(state) {
      state.saving = false;
      state.error = true;
    },
    reset() {
      return initialState;
    },
  },
});
export default slice;
